var map = {
	"./0B.png": 109,
	"./0G.png": 110,
	"./0R.png": 111,
	"./0Y.png": 112,
	"./1B.png": 113,
	"./1G.png": 114,
	"./1R.png": 115,
	"./1Y.png": 116,
	"./2B.png": 117,
	"./2G.png": 118,
	"./2R.png": 119,
	"./2Y.png": 120,
	"./3B.png": 121,
	"./3G.png": 122,
	"./3R.png": 123,
	"./3Y.png": 124,
	"./4B.png": 125,
	"./4G.png": 126,
	"./4R.png": 127,
	"./4Y.png": 128,
	"./5B.png": 129,
	"./5G.png": 130,
	"./5R.png": 131,
	"./5Y.png": 132,
	"./6B.png": 133,
	"./6G.png": 134,
	"./6R.png": 135,
	"./6Y.png": 136,
	"./7B.png": 137,
	"./7G.png": 138,
	"./7R.png": 139,
	"./7Y.png": 140,
	"./8B.png": 141,
	"./8G.png": 142,
	"./8R.png": 143,
	"./8Y.png": 144,
	"./9B.png": 145,
	"./9G.png": 146,
	"./9R.png": 147,
	"./9Y.png": 148,
	"./D2B.png": 149,
	"./D2G.png": 150,
	"./D2R.png": 151,
	"./D2Y.png": 152,
	"./D4W.png": 153,
	"./W.png": 154,
	"./_B.png": 155,
	"./_G.png": 156,
	"./_R.png": 157,
	"./_Y.png": 158,
	"./skipB.png": 159,
	"./skipG.png": 160,
	"./skipR.png": 161,
	"./skipY.png": 162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55;